import { render, staticRenderFns } from "./ThgClosing.vue?vue&type=template&id=0f7863bd&scoped=true&"
import script from "./ThgClosing.vue?vue&type=script&lang=ts&"
export * from "./ThgClosing.vue?vue&type=script&lang=ts&"
import style0 from "./ThgClosing.vue?vue&type=style&index=0&id=0f7863bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7863bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VOverlay,VProgressCircular})
